export default {
  listMoedas: [],
  moeda: {
    nome: '',
    descricao: '',
    ativo: true,
  },
}
